module.exports = __webpack_public_path__ + "static/ebook1-c77335478ed98bbc0d9b4b94aa99a4cb.gif";